import { useQuery } from 'react-query'
import axios from 'axios'
import { getApiServer } from '../../utils/helpers'

export default function useSignIn () {
  return useQuery('sign-in', async () => {
    const response = await axios.get(`${getApiServer()}/signin`, { withCredentials: true })
    return response.data
  }, {
    staleTime: Infinity,
    cacheTime: Infinity,
    retry: 0,
    keepPreviousData: true,
    enabled: false
  })
}